import React from 'react';
import red from '@material-ui/core/colors/red';
import Avatar from '@material-ui/core/Avatar';

export default [{
  from: 'Agata Zradzińska',
  message: 'Proszę o potwierdzenie zgłoszenia',
  avatar: <Avatar alt='Ali Connors' src='/static/images/avatars/Agata_Zradzinska.jpg' />,
  subject: 'Firma X'
}, {
  from: 'Anna Młyniec',
  message: 'Adipiscing Mattis',
  avatar: <Avatar alt='Sandra Adams' src='/static/images/avatars/Anna_Mlyniec.jpg' />,
  subject: 'Lorem ipsum'
}, {
  from: 'Anna Krześniak',
  message: 'Adipiscing Mattis',
  avatar: <Avatar alt='Sandra Adams' src='/static/images/avatars/Anna_Krzesniak.jpg' />,
  subject: 'Lorem ipsum'
}, {
  from: 'Jeff Jones',
  message: 'Consectetur Dolor',
  avatar: <Avatar aria-label="Post" style={{backgroundColor: red[500]}}>J</Avatar>,
  subject: 'Ullamcorper Bibendum Ligula'
}]


// WEBPACK FOOTER //
// ./src/utils/mock/feed.js